import React from 'react';
export const LearnMoreLink = ({ href }) => {
    // this component is currently being rendered in another anchor element and this ignores parent click
    const handleClick = (event) => {
        event.stopPropagation();
    };
    return (React.createElement("a", { href: href, target: "_blank", rel: "noreferrer", onClick: handleClick }, "Learn more"));
};
